import { ReactionType } from './../../../../models/clubs/reaction-type.model';
import { ReactionTypeService } from './../../../../services/clubs/reaction-type.service';
import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

@Component({
    selector: 'app-add-new-reaction',
    templateUrl: './add-new-reaction.component.html',
    styleUrls: ['./add-new-reaction.component.scss'],
})
export class AddNewReactionComponent implements OnInit {
    @Output()
    onReactionAdded: EventEmitter<string> = new EventEmitter<string>();
    reactionTypes: ReactionType[];
    @ViewChild('outside') outside: ElementRef;

    constructor(protected reactionTypeService: ReactionTypeService) {
        this.reactionTypeService.getAllReactionTypes().subscribe((result) => {
            this.reactionTypes = result;
        });
    }

    ngOnInit(): void {}

    addReaction(typeReactionId: string) {
        this.onReactionAdded.emit(typeReactionId);
        this.setFocusOutside();
    }

    setFocusOutside() {
        this.outside.nativeElement.focus();
    }
}
